export default function createObserver() {
  const subscriptions = {}

  return {
    subscribe(type, callback) {
      if (!subscriptions[type]) {
        subscriptions[type] = []
      }

      subscriptions[type].push(callback)
    },

    middleware(store) {
      return (next) => (action) => {
        const result = next(action)

        setTimeout(() => {
          const subs = subscriptions[action.type]

          if (subs && subs.length > 0) {
            subs.forEach((sub) => sub(store))
          }
        }, 0)

        return result
      }
    },
  }
}
